import type { SelectOption } from '@melt-ui/svelte';
import { match } from 'ts-pattern';
import { safe } from '$lib/utils/string';
import type { ExperienceLevelEnum } from '$gql/graphql';
import { experienceLevelEnumValues } from '$gql/zod-generated';
import type { Choice } from '$components/Form/PrettyMultiChoice.svelte';

export type Value = ExperienceLevelEnum;

export function valueToLabel(eb: Value): string {
    return match(eb)
        .with('from_0_to_2', () => safe`Entre 0 et 2 ans`)
        .with('from_2_to_5', () => safe`Entre 2 et 5 ans`)
        .with('from_0_plus', () => safe`0 an et plus`)
        .with('from_1_plus', () => safe`1 an et plus`)
        .with('from_2_plus', () => safe`2 ans et plus`)
        .with('from_3_plus', () => safe`3 ans et plus`)
        .with('from_4_plus', () => safe`4 ans et plus`)
        .with('from_5_plus', () => safe`5 ans et plus`)
        .with('from_6_plus', () => safe`6 ans et plus`)
        .with('from_7_plus', () => safe`7 ans et plus`)
        .with('from_8_plus', () => safe`8 ans et plus`)
        .with('from_9_plus', () => safe`9 ans et plus`)
        .with('from_10_plus', () => safe`10 ans et plus`)
        .exhaustive();
}

export const values = experienceLevelEnumValues;

export function valueToOption(value: Value): SelectOption<Value> {
    return {
        value,
        label: valueToLabel(value),
    };
}

export function areEqual(a: Value, b: Value) {
    return a === b;
}

export const selectOptions: readonly SelectOption<Value>[] = values.map(valueToOption);

export const prettyChoices: readonly Choice<Value>[] = selectOptions.map((o) => ({
    value: o.value,
    key: o.label ?? '',
    label: o.label ?? '',
}));
